import { Modal } from "@mui/material";

const GenericModal = ({ open, onClose, children }) => {
  if (!open) return null;
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="invite-modal"
      aria-describedby="invite-modal-description"
    >
      {children}
    </Modal>
  );
};

export default GenericModal;
